'use strict';

function _equalLogs(a, b) {
	return a.event === b.event && a.time === b.time;
}

export default function($log, incidents) {
	'ngInject';

	return {
		controller: Incident,
		controllerAs: '$incident',
		link: {
			pre: preLink,
		},
		scope: true,
	};


	function preLink(scope, element, attrs, $incident) {
		$incident.parentElement = element[0];
		element.addClass('loading');
		$incident.uuid = attrs.uuid;
		$incident.$ready = incidents.get($incident).finally(function() {
			element.removeClass('loading');
		});
	}
}

function Incident(incidents, $timeout) {
	'ngInject';

	const vm = {
		removingLogEntry: false,
	};

	vm.refresh = function() {
		incidents.get(vm, true);
	}

	vm.addLogEntry = function(entry) {
		vm.removingLogEntry = false;
		if (!vm.log) {
			vm.log = [entry];
		} else {
			let found = false;
			for (let _entry of vm.log) {
				if (_equalLogs(entry, _entry)) {
					found = true;
					break;
				}
			}
			if (!found) {
				vm.log.push(entry);
				console.log('New log entry pushed', entry);
			}
		}
		incidents.process(vm);
	}

	vm.removeLogEntry = function(entry) {
		vm.removingLogEntry = true;
		$timeout(() => {
			vm.removingLogEntry = false;
		}, 600);
		const oldLength = vm.log.length;
		vm.log = vm.log.filter(function(_entry) {
			return !_equalLogs(entry, _entry);
		});
		if (oldLength > vm.log.length) {
			console.log('Log entries removed matching', entry);
		}
		incidents.process(vm);
	}

	return vm;
}
